import React, { ReactElement } from 'react'
// import AppRouter from './AppRouter';
import { NotFoundPage } from './Pages/pageNotFound'
import { TermsOfSevice } from './Pages/TermsOfService'
import { About } from './Pages/About'

import { SignInPage } from './Pages/signIn/signIn'
import Registration from './Pages/registration/registration'
import { ForgotPasswordPage } from './Pages/forgotPassword/forgotPassword'
import MDSTool from './Pages/MDSTool/MetaDataDrillThruSetTool'
import NTSP_StatPortal from './Components/NTSP_StatPortal/NTSP_StatPortal'
import PSFS_StatPortal from './Components/PSFS_StatPortal/PSFS_StatPortal'

// TODO Do we need to distinguish protected and non protected routes yet?
// TODO remove all uses of 'any'
const routes: any = {
    'react/noPageFound': <NotFoundPage />,
    terms: <TermsOfSevice />,
    about: <About />,
    signin: <SignInPage />,
    register: <Registration />, //TODO pass optiosn some how
    'forgot-password': <ForgotPasswordPage />,
    DrillThruSetManagement: <MDSTool />,
}
const components: any = {
    // TestEmbed: <TestEmbed />,
    NTSP_StatPortal: <NTSP_StatPortal />,
    PSFS_StatPortal: <PSFS_StatPortal />,
}

function App({ options }: any) {
    const component: ReactElement = !options.isPageView
        ? components[options.componentName] || <NotFoundPage />
        : routes[window.location.hash.replace('#', '').split('?')[0]] || <NotFoundPage />
    return <div className="App">{React.cloneElement(component, options.props)}</div>
}

export default App
